<template>
  <div class="px-10">
    <v-expansion-panels
      v-model="panel"
      multiple
      class="elevation-2"
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="font-calibri font-16 font-weight-bold border-bottom-light-grey accordion-max-height">
          {{ section }}
          <div style="white-space:nowrap">
            <employee-profile-general-info-personal-detail-dialog-edit
              v-if="!loading && panel.length > 0 && $hasPermissionTo(['update employees details']) && !isMyProfile && !isResigned"
              :personal-detail="personalDetail"
              :employee-uid="employeeUid"
              @updated="loadPersonalDetails(); $emit('updated')"
            />
            <employee-profile-general-info-personal-detail-history-dialog-list-histories
              v-if="!loading && panel.length > 0 && $hasPermissionTo(['view hris employees']) && !isMyProfile && !isResigned"
              :personal-detail="personalDetail"
              :employee-uid="employeeUid"
              :is-resigned="isResigned"
              :histories="histories"
              @updated="loadPersonalDetails(); $emit('updated')"
            />
          </div>
          <v-spacer />
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-2">
          <v-row class="font-calibri">
            <v-col
              cols="4"
              class="pb-0"
            >
              <v-row no-gutters> 
                <v-col cols="3"> 
                  <span class="font-weight-bold">Title</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>

                <v-col cols="8">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else> {{ title ? title : 'N/A' }}</span>
                </v-col>

                <v-col cols="3"> 
                  <span class="font-weight-bold">Name</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="8">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>  {{ name ? name : 'N/A' }}</span>
                </v-col>

                <v-col cols="3"> 
                  <span class="font-weight-bold">Alias</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="8">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>  {{ alias ? alias : 'N/A' }}</span>
                </v-col>
  
                <v-col cols="3"> 
                  <span class="font-weight-bold">IC No.</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="8">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>  {{ ic ? ic : 'N/A' }}</span>
                </v-col>

                <v-col cols="3"> 
                  <span class="font-weight-bold">Date of Birth</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="8">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ dob ? $moment(dob).format('DD MMM YYYY') : 'N/A' }}</span>
                </v-col>

                <v-col cols="3"> 
                  <span class="font-weight-bold">Age</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="8">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ dob ? $moment().diff($moment(dob,'YYYY-MM-DD'), 'years') : 'N/A' }}</span>
                </v-col>

                <v-col cols="3"> 
                  <span class="font-weight-bold">Gender</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="8">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ gender ? gender : 'N/A' }}</span>
                </v-col>

                <v-col cols="3"> 
                  <span class="font-weight-bold">Disabled</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="8">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ isDisabled ? 'Yes' : 'No' }}</span>
                </v-col>
              </v-row>
            </v-col>
 
            <v-col
              cols="4"
              class="pb-0"
            >
              <v-row no-gutters> 
                <v-col cols="5"> 
                  <span class="font-weight-bold">Citizenship</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ citizenship ? citizenship : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">Place of Birth</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ placeOfBirth ? placeOfBirth : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">Marital Status</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ maritalStatus ? maritalStatus : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">Marriage Date</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ marriageDate ? $moment(marriageDate).format('DD MMM YYYY') : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">Ethnicity</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ ethnic ? ethnic : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">Religion</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ religion ? religion : 'N/A' }}</span>
                </v-col>
                
                <v-col cols="5"> 
                  <span class="font-weight-bold">Family Size</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ dependent }}</span>
                </v-col>

                <!-- Passport & Work Permit -- ONLY ENABLED WHEN NEEDED -->
                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="5"
                > 
                  <span class="font-weight-bold">Passport No.</span>
                </v-col>
                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="1"
                >
                  :
                </v-col>
                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="6"
                >
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ passportNo ? passportNo : 'N/A' }}</span>
                </v-col>

                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="5"
                > 
                  <span class="font-weight-bold">Passport Issue Date</span>
                </v-col>
                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="1"
                >
                  :
                </v-col>
                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="6"
                >
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ passportIssueDate ? $moment(passportIssueDate).format('DD MMM YYYY') : 'N/A' }}</span>
                </v-col>

                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="5"
                > 
                  <span class="font-weight-bold">Passport Expiry Date</span>
                </v-col>
                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="1"
                >
                  :
                </v-col>
                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="6"
                >
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ passportExpiryDate ? $moment(passportExpiryDate).format('DD MMM YYYY') : 'N/A' }}</span>
                </v-col>

                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="5"
                > 
                  <span class="font-weight-bold">Work Permit No.</span>
                </v-col>
                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="1"
                >
                  :
                </v-col>
                <v-col
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'" 
                  cols="6"
                >
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ workPermitNo ? workPermitNo : 'N/A' }}</span>
                </v-col>

                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="5"
                > 
                  <span class="font-weight-bold">Work Permit Approval Date</span>
                </v-col>
                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="1"
                >
                  :
                </v-col>
                <v-col
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'" 
                  cols="6"
                >
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ workPermitApprovedDate ? $moment(workPermitApprovedDate).format('DD MMM YYYY') : 'N/A' }}</span>
                </v-col>

                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="5"
                > 
                  <span class="font-weight-bold">Work Permit Expiry Date</span>
                </v-col>
                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="1"
                >
                  :
                </v-col>
                <v-col 
                  v-show="passportNo && personalDetail.person.lookup_citizenship && personalDetail.person.lookup_citizenship.value != 'MY'"
                  cols="6"
                >
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ workPermitExpiryDate ? $moment(workPermitExpiryDate).format('DD MMM YYYY') : 'N/A' }}</span>
                </v-col>
              </v-row>
            </v-col>

            <v-col
              cols="4"
              class="pb-0"
            >
              <v-row no-gutters> 
                <v-col cols="5"> 
                  <span class="font-weight-bold">Address</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>  {{ address ? address : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">Postcode</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ postcode ? postcode : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">City</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ city ? city : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">State</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ state ? state : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">Country</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ country ? country : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">Correspondence Phone No</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ correspondencePhoneNo ? correspondencePhoneNo : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">Handphone No</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ phoneNo ? phoneNo : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">Company Email</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ email ? email : 'N/A' }}</span>
                </v-col>

                <v-col cols="5"> 
                  <span class="font-weight-bold">Personal Email</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col cols="6">
                  <v-skeleton-loader
                    v-if="loading"
                    type="list-item"
                    class="loading-bar"
                  />  
                  <span v-else>{{ personalEmail ? personalEmail : 'N/A' }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileGeneralInfoPersonalDetailDialogEdit: () => import('@/components/hris/employee/profile/general-info/personal-detail/DialogEdit'),
      EmployeeProfileGeneralInfoPersonalDetailHistoryDialogListHistories: () => import('@/components/hris/employee/profile/general-info/personal-detail/history/DialogListHistories'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        section: 'Personal Details',
        title: null,
        passportNo: null,
        marriageDate: null,
        name: null,
        passportIssueDate: null,
        passportExpiryDate: null,
        dependent: 0,
        postcode: null,
        maritalStatus: null,
        gender: null,
        phoneNo: null,
        workPermitExpiryDate: null,
        placeOfBirth: null,
        citizenship: null,
        country: null,
        workPermitApprovedDate: null,
        religion: null,
        state: null,
        workPermitNo: null,
        dob: null,
        ethnic: null,
        city: null,
        email: null,
        personalEmail: null,
        alias: null,
        ic: null,
        address: null,
        correspondencePhoneNo: null,
        loading: false,
        panel: [0],
        personalDetail: {},
        isDisabled: 0,
        histories: [],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
    },
  
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadPersonalDetails()
          }
        },
      },
    },
  
    methods: {
      loadPersonalDetails () {
        this.loading = true

        this.$api.personalDetails().list(this.employeeUid)
          .then(res => {
            this.personalDetail = res.data

            this.email = res.data.email
            this.personalEmail = res.data.person.personal_email_address
            this.workPermitApprovedDate = res.data.work_permit_approved_date
            this.workPermitExpiryDate = res.data.work_permit_expiry_date
            this.workPermitNo = res.data.work_permit_number
            this.isDisabled = res.data.is_disabled

            this.phoneNo = (res.data.person || {}).handphone_number
            this.address = this.checkCommaExist((res.data.person || {}).address_line_1) + ((res.data.person || {}).address_line_2 ? this.checkCommaExist((res.data.person || {}).address_line_2) : '') + ((res.data.person || {}).address_line_3 ? this.checkCommaExist((res.data.person || {}).address_line_3) : '')
            this.postcode = (res.data.person || {}).postcode 
            this.city = ((res.data.person || {}).city || {}).name
            this.state = ((res.data.person || {}).state || {}).name
            this.country = ((res.data.person || {}).country || {}).name
            this.name = res.data.person.name
            this.alias = res.data.person.alias
            this.dob = res.data.person.dob
            this.marriageDate = (res.data.person || {}).marriage_date
            this.dependent = res.data.person.no_of_dependent
            this.placeOfBirth = this.passportNo ? ((res.data.person || {}).lookup_state || {}).description1 : ((res.data.person || {}).lookup_state || {}).description2
            this.title = ((res.data.person || {}).lookup_title || {}).description2
            this.citizenship = ((res.data.person || {}).lookup_citizenship || {}).description2
            this.maritalStatus = ((res.data.person || {}).lookup || {}).description2
            this.gender = ((res.data.person || {}).lookup_gender || {}).description2
            this.ethnic = ((res.data.person || {}).lookup_ethnicity || {}).description2
            this.religion = ((res.data.person || {}).lookup_religion || {}).description2
            this.ic = ((res.data.person || {}).identity_card || {}).ic_number
            this.passportNo = ((res.data.person || {}).identity_card || {}).passport_number
            this.passportIssueDate = ((res.data.person || {}).identity_card || {}).passport_issue_date
            this.passportExpiryDate = ((res.data.person || {}).identity_card || {}).passport_expiry_date
            this.correspondencePhoneNo = (res.data.person || {}).phone_number
            this.histories = (res.data.person || {}).histories

            this.loading = false
          })
      },

      checkCommaExist (string) {
        if (!string) {
          return 'N/A'
        }

        if (string.substr(string.length - 1) === ',') {
          return string
        } else {
          return string + ','
        }
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}

.font-14{
  font-size:14px;
}

.border-bottom-light-grey{
  border-bottom:1px solid #e6e6e6;
}

.accordion-max-height{
  max-height: 36px !important;
}

.border{
  border:1px solid #e6e6e6;
}

.loading-bar >>> .v-skeleton-loader__list-item.v-skeleton-loader__bone{
  max-height:24px !important;
  padding-left:0px !important
}
</style>
